import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import {withStyles} from "@material-ui/core/styles";

const styles = {
  input: {
    "paddingTop": `14px`,
    "paddingBottom": `14px`,
    "&:hover": {
      backgroundColor: `rgba(0, 0, 0, 0.08)`
    }
  }
};

class MSelect extends React.Component {
  static propTypes = {
    name: PropTypes.string,
    isOpen: PropTypes.bool,
    label: PropTypes.string,
    current: PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    }),
    onChange: PropTypes.func,
    onPreviewHover: PropTypes.func,
    options: PropTypes.array,
    optionStyles: PropTypes.func,
    classes: PropTypes.object
  };
  static defaultProps = {
    isOpen: false
  };
  state = {
    labelWidth: 0,
    isOpen: this.props.isOpen
  };
  InputLabelRef = React.createRef();
  componentDidMount() {
    /* eslint-disable react/no-find-dom-node*/
    this.setState({
      labelWidth: ReactDOM.findDOMNode(this.InputLabelRef.current).offsetWidth
    });
    /* eslint-enable react/no-find-dom-node*/
  }
  handleOpen = () => {
    this.setState({
      isOpen: true
    });
  };
  handleClose = () => {
    this.setState({
      isOpen: false
    });
  };
  render() {
    const {
      current,
      onChange,
      onPreviewHover,
      label,
      options,
      optionStyles,
      classes
    } = this.props;
    const {labelWidth, isOpen} = this.state;
    return (
      <FormControl variant="outlined" fullWidth>
        <InputLabel
          ref={this.InputLabelRef}
          htmlFor={`outlined-${name}-simple`}
        >
          {label}
        </InputLabel>
        <Select
          open={isOpen}
          onClose={this.handleClose}
          onOpen={this.handleOpen}
          value={current.value}
          name={name}
          onChange={onChange}
          input={
            <OutlinedInput
              labelWidth={labelWidth}
              classes={{input: classes.input}}
              id={`outlined-${name}-simple`}
            />
          }
        >
          {options.map((option) => {
            const optionCSS = (optionStyles && optionStyles(option)) || {};
            return (
              <MenuItem
                key={option.label}
                value={option.value}
                style={optionCSS}
                onMouseEnter={() => {
                  if (isOpen) {
                    onPreviewHover(option.value);
                  }
                }}
              >
                {option.label}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    );
  }
}

export default withStyles(styles)(MSelect);
